import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import User from 'flarum/common/models/User';
import UserCard from 'flarum/forum/components/UserCard';
import { findFirstVdomChild } from './util/findVdomChild';
/**
 * Opens the SelectFollowLevelModal with the provided user.
 */
function openFollowLevelModal(user) {
  if (!(user instanceof User)) return;
  app.modal.show(() => import(/* webpackChunkName: 'forum/components/SelectFollowLevelModal', webpackMode: 'lazy-once' */ './components/SelectFollowLevelModal'), {
    user
  });
}
export default function addFollowControls() {
  // @ts-expect-error - extend typing doesn't handle static method signatures with multiple parameters well
  extend(UserControls, 'userControls', function (items, user, _isContextControls) {
    const typedUser = user;
    const followingBlockingUser = !typedUser.canBeFollowed() && typedUser.followed();
    const icon = 'fas fa-user-friends';
    if (followingBlockingUser) {
      items.add('unfollow', m(Button, {
        icon: icon,
        onclick: async () => {
          await typedUser.save({
            followUsers: null
          });
          m.redraw();
        }
      }, app.translator.trans('ianm-follow-users.forum.user_controls.unfollow_button')));
    }
    if (!app.session.user || app.session.user === typedUser || !typedUser.canBeFollowed() || followingBlockingUser || app.forum.attribute('ianm-follow-users.button-on-profile') && !(app.current.data.routeName === 'fof_user_directory' && app.forum.attribute('userDirectorySmallCards'))) {
      return;
    }
    items.add('follow', m(Button, {
      icon: icon,
      onclick: openFollowLevelModal.bind(this, typedUser)
    }, app.translator.trans("ianm-follow-users.forum.user_controls.".concat(typedUser.followed() ? 'change_button' : 'follow_button'))));
  });
  extend(UserCard.prototype, 'view', function (view) {
    var _view$attrs;
    const user = this.attrs.user;
    if (!user) return;
    if (!app.forum.attribute('ianm-follow-users.button-on-profile') || !app.session.user || app.session.user === user || !user.canBeFollowed() || (_view$attrs = view.attrs) != null && (_view$attrs = _view$attrs.className) != null && _view$attrs.includes('UserCard--small')) {
      return;
    }
    const followButton = m(Button, {
      className: "Button Button--follow-profile",
      icon: "fas fa-user-friends",
      onclick: openFollowLevelModal.bind(this, user)
    }, user.followed() ? app.translator.trans("ianm-follow-users.forum.badge.label.".concat(user.followed())) : app.translator.trans('ianm-follow-users.forum.user_controls.follow_button'));
    findFirstVdomChild(view, '.UserCard-profile', vdom => {
      if (Array.isArray(vdom.children)) {
        vdom.children.splice(2, 0, followButton);
      }
    });
  });
}flarum.reg.addChunkModule('586', '163', 'ianm-follow-users', 'forum/components/SelectFollowLevelModal');